import { tv } from "tailwind-variants";

import { UILabel } from "../../../components/Product/Label/label.style";

export const label = tv({
    extend: UILabel
});
